import { matchPath } from "react-router-dom";

/**
 * Куда ведёт кнопка «Назад» с каждого экрана витрины.
 *
 * Переходы заданы явно, а не через историю браузера, по двум причинам.
 * Покупатель часто приходит по ссылке сразу на карточку товара — истории тогда
 * нет, и `navigate(-1)` вывел бы его из магазина. А с экрана «Заказ принят»
 * шаг назад по истории вернул бы в чекаут, то есть предложил бы оформить тот же
 * заказ второй раз.
 *
 * Шаблоны совпадают с картой маршрутов в app/AppRoutes.tsx.
 */
interface BackRule {
  /** Шаблон маршрута, целиком. */
  pattern: string;
  /** Путь родителя относительно корня магазина; пустая строка — каталог. */
  parent: string | null;
}

const RULES: ReadonlyArray<BackRule> = [
  // С «Заказ принят» — в каталог, а не в чекаут: заказ уже оформлен.
  { pattern: "/s/:slug/checkout/success", parent: "" },
  { pattern: "/s/:slug/checkout", parent: "cart" },
  { pattern: "/s/:slug/cart", parent: "" },
  { pattern: "/s/:slug/product/:productId", parent: "" },
  { pattern: "/s/:slug/orders/:orderId", parent: "orders" },
  { pattern: "/s/:slug/orders", parent: "" },
  // Каталог — корень витрины: здесь кнопку прячем, из магазина выходят
  // штатным закрытием Telegram.
  { pattern: "/s/:slug", parent: null },
];

/**
 * backTarget — куда вести с этого адреса. null означает «кнопку не показывать»:
 * это и каталог, и любой неизвестный адрес, откуда уводить некуда.
 */
export function backTarget(pathname: string): string | null {
  for (const rule of RULES) {
    const match = matchPath({ path: rule.pattern, end: true }, pathname);
    if (match === null) {
      continue;
    }
    if (rule.parent === null) {
      return null;
    }
    const slug = match.params.slug ?? "";
    return rule.parent === "" ? `/s/${slug}` : `/s/${slug}/${rule.parent}`;
  }
  return null;
}
